import { makeActionCreator } from '../../../utilities'
import { PatientMedicationsConstants } from './patientMedications.constants'

export const setName = makeActionCreator(
  PatientMedicationsConstants.SET_NAME,
  'name',
  'patientMedication',
  'iOptionValue'
)
export const setDose = makeActionCreator(PatientMedicationsConstants.SET_DOSE, 'dose', 'patientMedication')
export const setDoseUnits = makeActionCreator(
  PatientMedicationsConstants.SET_DOSE_UNITS,
  'doseUnits',
  'patientMedication'
)
export const setRoute = makeActionCreator(PatientMedicationsConstants.SET_ROUTE, 'route', 'patientMedication')
export const setFrequency = makeActionCreator(
  PatientMedicationsConstants.SET_FREQUENCY,
  'frequency',
  'patientMedication'
)
export const setPatientMedications = makeActionCreator(
  PatientMedicationsConstants.SET_PATIENT_MEDICATIONS,
  'patientMedications'
)
export const setCurrentMedication = makeActionCreator(
  PatientMedicationsConstants.SET_CURRENT_MEDICATION,
  'currentMedication'
)
export const addMedication = makeActionCreator(PatientMedicationsConstants.ADD_MEDICATION)
export const deleteMedication = makeActionCreator(PatientMedicationsConstants.DELETE_MEDICATION, 'patientMedication')
export const setPatientMedication = makeActionCreator(PatientMedicationsConstants.SET_MEDICATION, 'patientMedication')
export const setPatientMedicationsList = makeActionCreator(
  PatientMedicationsConstants.SET_MEDICATIONS_LIST,
  'patientMedicationsList'
)
export const setPatientMedicationPNNV = makeActionCreator(
  PatientMedicationsConstants.SET_MEDICATION_PNNV,
  'patientMedicationPNNV'
)
export const setShowSingleSelectLookup = makeActionCreator(
  PatientMedicationsConstants.SHOW_SINGLE_SELECT_LOOKUP,
  'showSingleSelectLookup'
)
export const setAreOptionsLoading = makeActionCreator(
  PatientMedicationsConstants.SET_ARE_OPTIONS_LOADING,
  'areOptionsLoading'
)
export const savePatientMedications = makeActionCreator(PatientMedicationsConstants.SAVE_PATIENT_MEDICATIONS)
export const setLastOralIntake = makeActionCreator(PatientMedicationsConstants.SET_LAST_ORAL_INTAKE, 'lastOralIntake')
export const setPatientMedicationPNNVToggle = makeActionCreator(
  PatientMedicationsConstants.SET_PATIENT_MEDICATION_PNNV_TOGGLE,
  '__patientMedicationPNNVToggle'
)
export const setSavePatientMedicationsResponse = makeActionCreator(PatientMedicationsConstants.SET_RESPONSE, 'response')
export const resetPatientMedicationsState = makeActionCreator(PatientMedicationsConstants.RESET_STATE)
